import { Flavour } from '@/enums'

export const isSbb = (flavour: string) => flavour === Flavour.SBB
export const isSpa = (flavour: string) => flavour === Flavour.SPA
export const isCpa = (flavour: string) => flavour === Flavour.CPA
export const isTpe = (flavour: string) => flavour === Flavour.TPE
